import { Badge } from "@volca/ui/components/ui/badge";
import {
  REFERRAL_STATUS_TO_BADGE_COLOR,
  REFFERRAL_STATUS_TO_SIDEBAR_TEXT,
} from "@/referrals/constants";
import type { ReferralStatus } from "@/referrals/referral";

interface SidebarBadgeProps {
  status: ReferralStatus | string;
}

export const SidebarBadge = ({ status }: SidebarBadgeProps) => {
  const isKnown = status in REFFERRAL_STATUS_TO_SIDEBAR_TEXT;
  const label = isKnown
    ? REFFERRAL_STATUS_TO_SIDEBAR_TEXT[status as ReferralStatus]
    : status.charAt(0) + status.slice(1).toLowerCase().replaceAll("_", " ");

  return (
    <Badge
      variant="secondary"
      color={
        isKnown
          ? REFERRAL_STATUS_TO_BADGE_COLOR[status as ReferralStatus]
          : "sand"
      }
    >
      {label}
    </Badge>
  );
};
